import {action, makeAutoObservable} from "mobx"
import {fileEditorStore} from "./FileEditorStore";
import {urls} from "../ApiUtils";

class FileListStore {
    storageKey = "fuel.list.data"
    fileNames: Array<string> = []
    selected: string = ""
    loading: boolean = false

    constructor() {
        makeAutoObservable(this)
    }

    loadList() {
        const target = urls.apiV1.gerberfiles.list()
        fetch(target.url, {
            method: target.method
        }).then((v) => {
            return v.json()
        }).then((loadedFileNamesData: Array<string>) => {
            this.updateState(loadedFileNamesData)
        });
    }

    @action
    selectByVal(selected: string) {
        this.selected = selected
        fileEditorStore.loadFileContent(selected)
    }

    @action
    private updateState(fileNames: any) {
        this.fileNames = fileNames || []
    }
}

export const fileListStore: FileListStore = new FileListStore()
